/**
 * selectionFlowService — frontend wrappers for the cell-selection flow's
 * explicit-action endpoints:
 *   POST /chat/conversations/{id}/next-step-interest  (validation upsell capture)
 *   POST /chat/conversations/{id}/manual-cell-add     (manual pick → candidate set)
 *
 * Each returns parsed JSON on success and throws on non-2xx. manual-cell-add is
 * called best-effort (telemetry) — callers swallow its errors.
 */
import { authenticatedFetch } from './authService.js'
import { getApiBase } from '../components/admin/analytics/shared/formatters.js'

const CONV = (publicId) => `${getApiBase()}/chat/conversations/${encodeURIComponent(publicId)}`

async function jsonOrThrow(res) {
  if (res.ok) return await res.json().catch(() => ({}))
  let detail = `HTTP ${res.status}`
  try {
    const b = await res.json()
    if (b && b.detail) detail = b.detail
  } catch {}
  throw new Error(detail)
}

/** Record the chosen validation next-step (and optional free-text message). */
export async function recordNextStepInterest(publicId, cta, message) {
  return jsonOrThrow(
    await authenticatedFetch(`${CONV(publicId)}/next-step-interest`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ cta, ...(message ? { message } : {}) }),
    }),
  )
}

/** Best-effort: persist + track a manually pinned cell. Never throws to caller. */
export async function recordManualCellAdd(publicId, cell, reason) {
  if (!publicId || !cell || !cell.manufacturer || !cell.name) return null
  try {
    return await jsonOrThrow(
      await authenticatedFetch(`${CONV(publicId)}/manual-cell-add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          manufacturer: cell.manufacturer,
          name: cell.name,
          ...(reason ? { reason } : {}),
        }),
      }),
    )
  } catch (err) {
    console.warn('[selectionFlowService] manual-cell-add failed (non-blocking):', err)
    return null
  }
}
